import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useAppDispatch, useAppSelector } from "application/store";
import { requestSelector } from "common/responseHandlerService/slice";
import {
  ButtonsContainer,
  ChartContainer,
  CloseButton,
  ModalContent,
  ModalOverlay,
  SeeFullChartButton,
} from "./styles";
import { ChartModalProps, FilterDataItem } from "./types";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  homeSelector as indicesDataSelector,
  setFilterIndices,
  setFilterMetric,
  resetState as resetIndicesData,
} from "common/valuationReports/store/slice";
import StockValuationActions from "common/valuationReports/store/actions";
import Chart from "features/chart";
import { useNavigate } from "react-router-dom";
import { PathNames } from "application/routes";

const ChartModal = ({
  selectedMetric,
  selectedIndex,
  onClose,
}: ChartModalProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const requestData = useAppSelector(requestSelector);
  const loading =
    requestData.getIndices.loading ||
    requestData.getIndicesData.loading ||
    requestData.getMetrics.loading;

  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down(1024));

  const { indicesData, filters } = useAppSelector(indicesDataSelector);

  const handleIndicesSelect = (item: FilterDataItem) => {
    dispatch(setFilterIndices(item));
  };

  const handleMetricSelect = (item: FilterDataItem) => {
    dispatch(setFilterMetric(item));
  };

  useEffect(() => {
    handleIndicesSelect(selectedIndex);
    handleMetricSelect(selectedMetric);
  }, []);

  useEffect(() => {
    if (filters.selectedIndices.code && filters.selectedMetric.code) {
      dispatch(StockValuationActions.getIndicesData());
    }
  }, [filters]);

  const onCloseHandler = () => {
    dispatch(resetIndicesData());
    onClose();
  };

  const seeFullChartHandler = () => {
    Promise.all([
      dispatch(StockValuationActions.getMetrics()),
      dispatch(StockValuationActions.getIndices()),
    ]).then(() => navigate(PathNames.valuationReports));
  };

  const modalRootElement = document.getElementById("modal");

  return createPortal(
    <ModalOverlay onClick={onCloseHandler}>
      <ModalContent onClick={(event) => event.stopPropagation()}>
        <ChartContainer>
          <Chart
            loading={loading}
            indicesData={indicesData}
            filters={filters}
            isTablet={isTablet}
            adjustedChartHeight={270}
          />
        </ChartContainer>
        <ButtonsContainer>
          <CloseButton onClick={onCloseHandler}>
            <p>Close</p>
          </CloseButton>
          <SeeFullChartButton onClick={seeFullChartHandler}>
            <p>See full chart</p>
          </SeeFullChartButton>
        </ButtonsContainer>
      </ModalContent>
    </ModalOverlay>,
    modalRootElement!
  );
};

export default ChartModal;
